import { twMerge } from "tailwind-merge";
import { getObjectionTitle, getPersonalityLabels, getPractitionerTypes } from "../../../services/utils";
import { ObjectionLevelConfig } from "../../../constant";

export function HCPListItem({ item, objections, tenantProfile, group, onClick, isSelected, hcpTag }: { item: any, objections: any[], tenantProfile: any, group: string, onClick: () => void, isSelected: boolean, hcpTag: string }) {
    const personalities = getPersonalityLabels(item?.personalityType, tenantProfile, group, hcpTag);
    const practitionerTypes = getPractitionerTypes(tenantProfile?.practitioner_types || {}, group) || [];
    const practitionerType = practitionerTypes.find((type) => type.key === item.practitionerType || type.type === item.practitionerType);
    const objectionLevelConfig = ObjectionLevelConfig[item.objectionLevel as keyof typeof ObjectionLevelConfig] ?? {
        backgroundColor: "#F3F4F6",
        color: "#374151",
    };
    return (
        <tr className={twMerge("[&_td]:py-2 [&_td:first-child]:pl-3 [&_td:last-child]:pr-3 hover:bg-gray-100 [&_td:first-child]:rounded-l-lg [&_td:last-child]:rounded-r-lg", isSelected ? "!bg-background2" : "")} role="button" onClick={() => onClick()}>
            <td>
                <div className="flex items-center justify-between gap-2">
                    <span className="text-black text-sm font-semibold">{practitionerType?.type || practitionerType?.key}</span>
                </div>
            </td>
            <td>
                {item.isLastHCP && <div className="h-[30px] flex items-center justify-center w-[150px] bg-[linear-gradient(180deg,var(--PraxisDarkRed)_-38.33%,var(--primary5)_183.33%)] text-white text-[clamp(10px,1.5vw,12px)] px-2 py-1 rounded-full">Last Selected HCP</div>}
            </td>
            <td>
                <div className="flex items-center justify-center bg-gray-100 h-[23px] rounded-md p-2 mx-12 font-semibold text-[10px] text-gray-800"> {personalities}</div>
            </td>
            <td>
                <div

                    className={twMerge("flex w-full items-center justify-center")}>
                    <div className="flex items-center justify-center rounded-md w-20 h-[23px] text-[10px] font-semibold" style={{
                        backgroundColor: objectionLevelConfig.backgroundColor,
                        color: objectionLevelConfig.color,
                    }}>

                        {getObjectionTitle(item.objectionLevel, objections)}
                    </div>
                </div>
            </td>
        </tr>
    )
}

export function HCPListView({
    data,
    onChange,
    isLoading,
    selectedCharacter,
    tenantProfile,
    group,
    objections,
    setForm,
    form,
    hcpTag,
}: {
    data: any[];
    onChange: (index: number) => void;
    isLoading: boolean;
    selectedCharacter: number;
    tenantProfile: any;
    group: string;
    objections: any[];
    setForm: (form: any) => void;
    form?: any;
    hcpTag: string;
}) {
    const { isLastHCP: _omitLastHcpFromForm, ...formWithoutLastHcp } = form ?? {};
    return (
        <div className="w-full">
            <table className="w-full border-separate border-spacing-y-1">
                <colgroup>
                    <col className="w-[40%]" />
                    <col className="w-[10%]" />
                    <col className="w-[25%]" />
                    <col className="w-[25%]" />
                </colgroup>
                <thead>
                    <tr className="[&_th]:py-2.5 [&_th:last-child]:pr-3 [&_th]:uppercase [&_th]:text-xs [&_th]:text-PraxisDarkRed [&_th]:font-semibold [&_th]:border-b [&_th]:border-gray-201">
                        <th className="text-left pl-3">AI HCP</th>
                        <th />
                        <th className="text-center">Personality Type</th>
                        <th className="text-center pr-3">{tenantProfile?.objections_title || "Objection Level"}</th>
                    </tr>
                </thead>
                <tbody className="before:content-[''] before:block before:h-1.5">
                    {data.map((item, index) => {
                        const displayItem =
                            selectedCharacter === index && form
                                ? { ...item, ...formWithoutLastHcp }
                                : item;
                        return (
                            <HCPListItem isSelected={selectedCharacter === index} onClick={() => onChange(index)} group={group} key={index} item={displayItem} objections={objections} tenantProfile={tenantProfile} hcpTag={hcpTag} />
                        );
                    })}
                </tbody>
            </table>
        </div>
    )
}